<template>
  <div class="limiter font-example">
    <div class="container-login">
      <v-container fluid class="votacao-container">
        <v-row align="center" justify="center" class="votacao-page-row">
          <v-col cols="12" sm="11" md="10" lg="9" xl="8" class="votacao-col">
            <v-card class="login votacao-shell" flat style="border-radius: 10px; padding: 0px;">
              <div style="margin: 5px; padding: 15px; text-align: center" v-if="carregamento == 'CARREGANDO'">
                <p>Carregando questionário...</p>
                <v-progress-linear max-width="100px" indeterminate color="blue"></v-progress-linear>
              </div>
              <div v-if="carregamento == 'VAZIO'" class="votacao-hub">
                <v-img v-if="empresa.logoUrl" :src="empresa.logoUrl" max-width="200" class="mx-auto mb-4" contain></v-img>
                <p class="votacao-hub-texto">Nenhuma pesquisa disponível no momento.</p>
              </div>
              <div v-if="carregamento == 'ERRO'" class="votacao-hub">
                <v-icon size="46" color="#c62828" class="mx-auto mb-4">mdi-alert-circle-outline</v-icon>
                <p class="votacao-hub-texto">{{ mensagemErro }}</p>
              </div>
              <div v-if="carregamento == 'HUB'" class="votacao-hub">
                <v-img v-if="empresa.logoUrl" :src="empresa.logoUrl" max-width="220" class="mx-auto mb-6" contain></v-img>
                <h2 class="votacao-hub-titulo">Escolha uma opção</h2>
                <v-btn
                  v-for="quest in questionariosEmpresa"
                  :key="quest.id"
                  block
                  large
                  rounded
                  color="#F9C028"
                  class="votacao-hub-btn mb-4"
                  @click="selecionarQuestionarioEmpresa(quest.id)"
                >
                  {{ quest.titulo }}
                </v-btn>
              </div>
              <div style="margin: 0px; padding: 0px" v-if="carregamento == 'CARREGADO'">
                <v-card outlined>
                  <v-stepper v-model="stepper">
                    <v-stepper-header v-show="false">
                      <v-stepper-step :complete="stepper > 1" step="1" class="stepperHeader">Início</v-stepper-step>
                      <div v-for="(item, index) in perguntas" :key="item.id">
                        <v-stepper-step :complete="stepper > (index + 2)" :step="index + 2" class="stepperHeader">{{item.titulo.substring(0,10)}}</v-stepper-step>
                      </div>
                      <v-stepper-step :step="quantidadeHeader" class="stepperHeader">Final</v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                      <v-stepper-content step="1" style="padding: 0px;" class="stepperItems">
                        <v-card class="votacao-hero-card">
                          <div class="votacao-hero-content">
                            <v-img :src="empresa.avatarUrl" class="votacao-logo-top" contain>
                              <template v-slot:placeholder>
                                <v-row class="fill-height ma-0" align="center" justify="center">
                                  <v-progress-circular indeterminate color="white"></v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                            <v-row dense align="center" justify="center" class="votacao-call-row">
                              <v-col cols="12" sm="10" md="8" lg="7" align="center" justify="center">
                              <h2 class="votacao-title votacao-title-yellow">QUEREMOS SABER</h2>
                              <h2 class="votacao-title votacao-title-white">QUAL FILME VOCÊ</h2>
                              <h2 class="votacao-title votacao-title-yellow votacao-title-last">MAIS GOSTOU</h2>
                              <!-- <v-btn @click="stepper++" depressed width="80%" rounded x-large color="#F9C028"><h1>Votar</h1></v-btn> -->
                              <img src="../../assets/botaoVotar.png" @click="stepper++" class="votacao-votar-btn" v-if="questionario.ativo">
                              </v-col>
                            </v-row>
                            <v-col cols="12" xs="12" sm="12" md="12" lg="12" align="center" justify="center" style="margin-top: 50px; padding: 0px 10px 0px 10px" v-if="questionario.exibeTermoLgpd">
                              <p style="margin: 0px; color: white; font-size: 12px">Ao usar nossa plataforma, você concorda com nossas <a target="_blank" style="color: white; text-decoration: underline" href="https://2eea8b7d-a702-46f5-8be7-466aa412f79b.usrfiles.com/ugd/2eea8b_6acd8479401b41da80bfe3bbf2a0d37d.pdf" @click.stop>políticas de privacidade e tratamento de dados pessoais</a>.</p>
                            </v-col>
                          </div>
                        </v-card>
                      </v-stepper-content>

                      <div v-for="(item, index) in perguntas" :key="item.id">
                        <v-stepper-content :step="index + 2" style="padding: 0px;" class="stepperItems">
                          <v-card class="votacao-hero-card votacao-question-card pb-1">
                            <div style="text-align: center">
                              <br>
                              <v-img :src="empresa.logoUrl" width="300px" class="mx-auto"></v-img>
                              <v-btn outlined dark style="margin-top: 20px" @click="voltarParaInicio" v-if="stepper != quantidadeHeader">
                                <v-icon left>mdi-home</v-icon>Ir para início
                              </v-btn>
                              <h2 class="mx-auto votacao-question-title">{{ item.titulo.toUpperCase() }}</h2>

                              <div v-if="item.tipo == 'NPS'">
                                <v-card outlined style="margin: 10px; border-radius: 50px" height="100%">
                                  <div v-for="number in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" :key="number" style="display: inline-block">
                                    <v-btn text class="d-flex flex-no-wrap justify-space-between" large height="80px" block @click="salvaResposta(number, '', '', '', 'SIM', undefined, undefined, undefined, item.id, (index + 2))">
                                      <img :src="require(`../../assets/artboard${number}.png`)" alt="" width="50px">
                                    </v-btn>
                                  </div>
                                </v-card>
                              </div>

                              <div v-if="item.tipo == 'MÚLTIPLA ESCOLHA'">
                                <v-col :cols="$vuetify.breakpoint.lg ? 6 : 12" class="mx-auto">
                                  <v-card outlined style="margin: 10px; border-radius: 50px" height="100%">
                                    <v-row dense>
                                      <v-col cols="6" lg="3">
                                        <v-btn text large height="80px" block @click="salvaResposta(0, '', '', 'RUIM', 'NAO', undefined, undefined, undefined, item.id, (index + 2))">
                                          <img :src="require(`../../assets/buttonruim.png`)" alt="" width="50px">
                                        </v-btn>
                                      </v-col>
                                      <v-col cols="6" lg="3">
                                        <v-btn text large height="80px" block @click="salvaResposta(0, '', '', 'BOM', 'NAO', undefined, undefined, undefined, item.id, (index + 2))">
                                          <img :src="require(`../../assets/buttonbom.png`)" alt="" width="50px">
                                        </v-btn>
                                      </v-col>
                                      <v-col cols="6" lg="3">
                                        <v-btn text large height="80px" block @click="salvaResposta(0, '', '', 'OTIMO', 'NAO', undefined, undefined, undefined, item.id, (index + 2))">
                                          <img :src="require(`../../assets/buttonotimo.png`)" alt="" width="50px">
                                        </v-btn>
                                      </v-col>
                                      <v-col cols="6" lg="3">
                                        <v-btn text large height="80px" block @click="salvaResposta(0, '', '', 'EXCELENTE', 'NAO', undefined, undefined, undefined, item.id, (index + 2))">
                                          <img :src="require(`../../assets/buttonexcelente.png`)" alt="" width="50px">
                                        </v-btn>
                                      </v-col>
                                    </v-row>
                                  </v-card>
                                </v-col>
                              </div>

                              <div v-if="item.tipo == 'FEEDBACK'">
                                <v-col :cols="$vuetify.breakpoint.lg ? 6 : 12" class="mx-auto">
                                  <v-card outlined style="margin: 10px; border-radius: 50px" height="100%">
                                    <v-row dense class="mx-auto">
                                      <v-col cols="12">
                                        <v-text-field
                                          outlined
                                          hide-details
                                          style="border-radius: 50px"
                                          color="#666666"
                                          placeholder="Digite aqui"
                                          v-model="textoFeedback"
                                        ></v-text-field>
                                      </v-col>
                                    </v-row>
                                  </v-card>
                                  <v-row dense class="mx-auto" style="margin-top: 50px">
                                    <v-col cols="12">
                                      <v-btn
                                        color="primary"
                                        @click="salvaResposta(0, textoFeedback, '', '', 'NAO', undefined, undefined, undefined, item.id, (index + 2))"
                                        rounded
                                      >Enviar</v-btn>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </div>

                              <div v-if="item.tipo == 'TELEFONE'">
                                <v-col :cols="$vuetify.breakpoint.lg ? 6 : 12" class="mx-auto">
                                  <v-card outlined style="margin: 10px; border-radius: 50px" height="100%">
                                    <v-row dense class="mx-auto">
                                      <v-col cols="12">
                                        <v-text-field
                                          outlined
                                          hide-details
                                          style="border-radius: 50px"
                                          color="#666666"
                                          placeholder="Digite aqui"
                                          v-mask="'(##) #####-####'"
                                          type="tel"
                                          v-model="textoTelefone"
                                        ></v-text-field>
                                      </v-col>
                                    </v-row>
                                  </v-card>
                                  <v-row dense class="mx-auto" style="margin-top: 50px">
                                    <v-col cols="12">
                                      <v-btn
                                        color="primary"
                                        @click="salvaResposta(0, '', textoTelefone, '', 'NAO', undefined, undefined, undefined, item.id, (index + 2))"
                                        rounded
                                      >Enviar</v-btn>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </div>

                              <div v-if="item.tipo == 'ESCALA'">
                                <div v-for="number in retornaEscala(item.escalaValor)" :key="number" style="display: inline-block">
                                  <v-btn tile style="margin: 5px" height="80px" @click="salvaResposta(0, '', '', '', 'NAO', undefined, undefined, number, item.id, (index + 2))">
                                    <p style="margin: 0px; font-size: 19px">{{ number }}</p>
                                  </v-btn>
                                </div>
                                <div style="margin-top: 15px">
                                  <p style="color: white"><i>Informe 1 para negativo e {{ item.escalaValor }} para positivo</i></p>
                                </div>
                              </div>

                              <div v-if="item.tipo == 'DICOTÔMICA'">
                                <v-card outlined style="margin: 10px; border-radius: 50px" height="100%">
                                  <v-row dense class="mx-auto">
                                    <v-col cols="12" lg="6">
                                      <v-btn text large height="80px" block @click="salvaResposta(0, '', '', '', 'NAO', 'SIM', undefined, undefined, item.id, (index + 2))" color="green">
                                        <v-icon left>mdi-check</v-icon>SIM
                                      </v-btn>
                                    </v-col>
                                    <v-col cols="12" lg="6">
                                      <v-btn text large height="80px" block @click="salvaResposta(0, '', '', '', 'NAO', 'NÃO', undefined, undefined, item.id, (index + 2))" color="red">
                                        <v-icon left>mdi-close</v-icon>NÃO
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </div>

                              <div v-if="item.tipo == 'ESCOLHA ÚNICA'">
                                <v-card outlined style="margin: 10px; border-radius: 50px" height="100%">
                                  <v-row dense class="mx-auto">
                                    <v-col cols="12" v-for="opcao in item.escolhas" :key="opcao">
                                      <v-btn text large height="80px" block @click="salvaResposta(0, '', '', '', 'NAO', undefined, opcao, undefined, item.id, (index + 2))" color="primary">
                                        {{ opcao }}
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </div>

                              <div v-if="item.tipo == 'ESCOLHA ÚNICA COM FOTO'">
                                <v-row dense class="mx-auto votacao-options-grid">
                                  <v-col cols="6" sm="6" md="4" lg="4" v-for="opcao in item.escolhas" :key="opcao.nome">
                                    <v-card
                                      class="votacao-movie-card"
                                      :class="{ 'votacao-movie-card-selected': opcao.selecionado }"
                                      flat
                                      @click="selecionaOpcao(opcao.nome, item.id)"
                                    >
                                      <v-img :src="opcao.foto" class="votacao-movie-image"></v-img>
                                    </v-card>
                                    <div
                                      class="votacao-movie-label"
                                      :class="{ 'votacao-movie-label-selected': opcao.selecionado }"
                                      @click="selecionaOpcao(opcao.nome, item.id)"
                                    >
                                      <v-img src="../../assets/checkMarcado.webp" class="votacao-movie-check" contain v-if="opcao.selecionado"></v-img>
                                      <v-img src="../../assets/checkDesmarcado.webp" class="votacao-movie-check" contain v-if="!opcao.selecionado"></v-img>
                                      <span>{{ opcao.nome }}</span>
                                    </div>
                                  </v-col>
                                  <v-col cols="12">
                                    <v-footer padless fixed class="votacao-confirm-footer" v-if="opcaoSelecionada">
                                      <v-card flat tile width="100%" class="text-center votacao-confirm-card">
                                        <v-card-text class="votacao-confirm-content">
                                          <v-btn
                                            depressed
                                            rounded
                                            large
                                            block
                                            class="votacao-confirm-btn"
                                            @click="salvaResposta(0, '', '', '', 'NAO', undefined, opcaoSelecionada, undefined, item.id, (index + 2))"
                                            color="#F9C028"
                                          >
                                            CONFIRMAR
                                          </v-btn>
                                        </v-card-text>
                                      </v-card>
                                    </v-footer>
                                  </v-col>
                                </v-row>
                              </div>
                            </div>
                          </v-card>
                        </v-stepper-content>
                      </div>

                      <v-stepper-content :step="quantidadeHeader" style="padding: 0px;" class="stepperItems">
                        <v-card class="votacao-hero-card votacao-final-card" v-if="perguntaInformativo.length == 0">
                          <div class="votacao-final-content">
                            <v-img :src="empresa.logoUrl" class="votacao-final-logo" contain></v-img>
                            <v-btn outlined dark class="votacao-home-btn" @click="voltarParaInicio">
                              <v-icon left>mdi-home</v-icon>Ir para início
                            </v-btn>
                            <div class="votacao-final-message">
                              <h3>SEU VOTO FOI COMPUTADO</h3>
                              <h1>OBRIGADO</h1>
                            </div>
                          </div>
                        </v-card>
                        <v-card class="votacao-hero-card votacao-final-card" v-else>
                          <div class="votacao-final-content">
                            <v-img :src="empresa.logoUrl" class="votacao-final-logo" contain></v-img>
                            <v-btn outlined dark class="votacao-home-btn" @click="voltarParaInicio">
                              <v-icon left>mdi-home</v-icon>Ir para início
                            </v-btn>
                            <div class="votacao-final-message">
                              <h1>{{ perguntaInformativo[0].textoInformativo }}</h1>
                            </div>
                          </div>
                        </v-card>
                      </v-stepper-content>
                    </v-stepper-items>
                  </v-stepper>
                </v-card>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <div
          class="login-title"
          :class="{
            'login-title-home': stepper == 1,
            'login-title-flow': stepper != 1,
            'login-title-with-confirm': stepper != 1 && opcaoSelecionada
          }"
        >
          <p style="margin: 0px 0px 10px 0px; color: white; font-size: 12px" v-if="(questionario.exibeTermoLgpd && empresa.bannerInicial) || (questionario.exibeTermoLgpd && !empresa.bannerInicial) && empresa.bannerInicial">Ao usar nossa plataforma, você concorda com nossas <a target="_blank" style="color: white; text-decoration: underline" :href="configuracoes.urlPoliticaPrivacidade" @click.stop>políticas de privacidade e tratamento de dados pessoais</a>.</p>
          <img :src="configuracoes.urlLogoEmpresa" width="140px">
        </div>
      </v-container>
    </div>
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  /* import vueCard from 'vue-card-express'; */
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl, /* modelBoleto */ } from '@/global'
  import Snackbar from '../../componentes/snackbar.vue'
  import { mapState } from 'vuex'
  import moment from 'moment'
  import axios from 'axios'
  export default {
    components: { Snackbar, Loading },
    name: 'Auth',
    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
    }),
    data: function () {
      return {
        isLoading: false,
        fullPage: true,
        carregamento: '',
        mensagemErro: '',
        textoFeedback: '',
        textoTelefone: '',
        opcaoSelecionada: '',
        codPesquisa: '',
        questionario: [],
        perguntas: [],
        empresa: [],
        stepper: 1,
        quantidadeHeader: 0,
        perguntaInformativo: [],
        questionariosEmpresa: [],
        empresaIdEvento: null,
        configuracoes: {},
        dictionary: {
          custom: {
            nomeCartao: {
              required: () => 'Informe o nome'
            },
            numCartao: {
              required: () => 'Informe o número do cartão de crédito',
            },
            cpftitular: {
              required: () => 'Informe o número do cartão de crédito',
            },
            codCartao: {
              required: () => 'Informe o código de segurança'
            },
            expiraCartaoMes: {
              required: () => 'Informe o mês de validade do cartão',
            },
            expiraCartaoAno: {
              required: () => 'Informe o ano de validade do cartão',
            },
            dateOfBirth: {
                required: () => 'Informe a Data de Nascimento' ,
                date_format: () => 'Informe uma data válida (dd/mm/aaaa)'
            },
          }
        }
      }
    },

    created: async function () {
      await this.configuracoesGerais()
    },
    
    mounted: function () {
      this.pegaParametrosUrl()
    },

    watch: {
      stepper() {
        if (this.carregamento !== 'CARREGADO') return
        if (this.stepper === this.passoFinalVotacao()) {
          setTimeout(() => {
            this.voltarParaInicio()
          }, 5000);
        }
      },
    },

    methods: {
      passoFinalVotacao() {
        return this.perguntas.length + 2
      },

      atualizaQuantidadeHeader() {
        this.quantidadeHeader = this.passoFinalVotacao()
      },

      async configuracoesGerais() {
        await axios.get(baseApiUrl + 'Configuracoes/info')
        .then(response => {
          if (response.data) {
            this.configuracoes = response.data
          }
        })
      },

      async pegaParametrosUrl() {
        this.carregamento = 'CARREGANDO'
        this.isLoading = true
        try {
          var params = window.location.search.substring(1).split('&');
          var paramArray = {};                        // Criar objeto que vai conter os parametros

          if (params[0] != '') {
            for (var i = 0; i < params.length; i++) {   // Passar por todos os parametros
              var param = params[i].split('=');         // Dividir os parametros chave e valor
              paramArray[param[0]] = param[1];          // Adicionar ao objeto criado antes
            }
          }

          if (paramArray['e']) {
            this.empresaIdEvento = paramArray['e']
            await this.carregaPorEmpresa(paramArray['e'])
          } else if (paramArray['q']) {
            this.empresaIdEvento = null
            this.geraCodPesquisa()
            await this.carregaInformacoes(paramArray['q'])
          } else {
            this.exibeErro('Problema ao carregar sua pesquisa. Tente novamente em instantes.')
          }
        } catch (erro) {
          this.exibeErro(this.mensagemDoErro(erro))
        }
        this.isLoading = false
      },

      exibeErro(mensagem) {
        this.mensagemErro = mensagem
        this.carregamento = 'ERRO'
      },

      mensagemDoErro(erro) {
        // Traduz o erro técnico numa mensagem amigável, sem expor detalhes do endpoint.
        const status = erro && erro.response && erro.response.status

        // Sem resposta do servidor (rede/servidor fora do ar).
        if (!status) {
          return 'Não conseguimos nos conectar agora. Verifique sua conexão e tente novamente.'
        }

        // Demais erros (422, 404, 500, etc.).
        return 'Problema ao carregar sua pesquisa. Tente novamente em instantes.'
      },

      async carregaPorEmpresa(empresaId) {
        this.empresaIdEvento = empresaId
        try {
          const { data } = await axios.post(
            baseApiUrl + 'Questionarios/ativosPorEmpresa',
            { empresaId }
          )
          const lista = data.questionarios || []
          if (data.empresa) {
            this.empresa = data.empresa
          }

          if (lista.length === 1) {
            this.geraCodPesquisa()
            await this.carregaInformacoes(lista[0].id)
            return
          }
          if (lista.length > 1) {
            this.questionariosEmpresa = lista
            this.carregamento = 'HUB'
            return
          }
          this.carregamento = 'VAZIO'
        } catch (erro) {
          this.exibeErro(this.mensagemDoErro(erro))
        }
      },

      async selecionarQuestionarioEmpresa(questionarioId) {
        this.carregamento = 'CARREGANDO'
        this.stepper = 1
        this.opcaoSelecionada = ''
        this.geraCodPesquisa()
        await this.carregaInformacoes(questionarioId)
      },

      async carregaInformacoes(questionarioId) {
        try {
          const response = await axios.post(baseApiUrl + 'Questionarios/infoQuestionario', {"questionarioId": questionarioId})

          if (!response.data || !response.data.questionario) {
            this.exibeErro('Problema ao carregar sua pesquisa. Tente novamente em instantes.')
            return
          }

          this.questionario = response.data.questionario
          this.empresa = response.data.empresa
          await this.carregaPerguntas(response.data.perguntas)
          this.carregamento = 'CARREGADO'
        } catch (erro) {
          this.exibeErro(this.mensagemDoErro(erro))
        }
      },

      async carregaPerguntas(perguntas) {
        perguntas = await this.verificaEscalaComFoto(perguntas)

        this.perguntaInformativo = perguntas.filter(pergunta => pergunta.tipo === 'INFORMATIVO')

        if (this.perguntaInformativo.length >= 1) {
          this.perguntas = perguntas.filter(pergunta => pergunta.id !== this.perguntaInformativo[0].id)
        } else {
          this.perguntas = perguntas
        }
        this.atualizaQuantidadeHeader()
      },

      transformaData(data, formato) {
        let date = moment(data).format(formato);
        return date
      },

      async salvaResposta(nota, feedback, telefone, classificacao, nps, dicotomica, escolhaUnica, escala, perguntaId, passo) {
        let dados = {
          "canal": "WEB",
          "nota": nota,
          "classificacao": classificacao,
          "feedback": feedback,
          "telefone": telefone,
          "padraoNPS": nps,
          "perguntaId": perguntaId,
          "questionarioId": this.questionario.id,
          "codPesquisa": this.codPesquisa,
          "dicotomica": dicotomica,
          "escolhaUnica": escolhaUnica,
          "escala": escala,
        }
        
        await axios.post(baseApiUrl + 'Respostas/salvar', dados)
        .then(response => {
          if (response.data) {
            this.stepper = passo + 1
            this.textoFeedback = ''
            this.textoTelefone = ''
            this.opcaoSelecionada = ''

            if (escolhaUnica) {
              this.selecionaOpcao(escolhaUnica, perguntaId)
            }
          }
        })

        this.scrollToTop()
      },

      async geraCodPesquisa() {
        await axios.get(baseApiUrl + 'Respostas/geraCodPesquisa')
        .then(response => {
          if (response.data) {
            this.codPesquisa = response.data.codPesquisa
          }
        })
      },

      retornaEscala(escalaValor) {
        let listaEscala = []

        for (let i = 0; i < escalaValor + 1; i++) {
          if (i > 0) {
            listaEscala.push(i)
          }
        }

        return listaEscala
      },

      verificaEscalaComFoto(lista) {
        for (let i = 0; i < lista.length; i++) {
          if (lista[i].tipo == 'ESCOLHA ÚNICA COM FOTO') {
            for (let j = 0; j < lista[i].escolhas.length; j++) {
              lista[i].escolhas[j].selecionado = false
            }
          }
        }

        return lista
      },

      selecionaOpcao(opcao, perguntaId) {
        for (let i = 0; i < this.perguntas.length; i++) {
          if (this.perguntas[i].id == perguntaId) {
            for (let j = 0; j < this.perguntas[i].escolhas.length; j++) {
              if (this.perguntas[i].escolhas[j].nome == opcao) {
                this.perguntas[i].escolhas[j].selecionado = !this.perguntas[i].escolhas[j].selecionado

                if (this.perguntas[i].escolhas[j].selecionado) {
                  this.opcaoSelecionada = this.perguntas[i].escolhas[j].nome
                } else {
                  this.opcaoSelecionada = ''
                }
              } else {
                this.perguntas[i].escolhas[j].selecionado = false
              }
            }
          }
        }
      },

      scrollToTop() {
        window.scroll({
          top: 0,
          behavior: 'smooth'
        });
      },

      async voltarParaInicio() {
        if (this.empresaIdEvento) {
          this.stepper = 1
          this.opcaoSelecionada = ''
          this.questionario = []
          this.perguntas = []
          this.quantidadeHeader = 0
          this.carregamento = 'CARREGANDO'
          await this.carregaPorEmpresa(this.empresaIdEvento)
          return
        }
        this.stepper = 1
        this.geraCodPesquisa()
      },
    }
  }
</script>

<style scoped>
  @font-face {
    font-family: 'Montserrat';
    src: url('~@/assets/Montserrat-Medium.ttf') format('opentype');
  }

  .font-example {
    font-family: 'Montserrat', sans-serif;
  }

  .limiter {
    width: 100%;
    min-height: 100vh;
    margin: 0 auto;
    background: #000;
    overflow-x: hidden;
  }

  .container-login {
    width: 100%;
    min-height: 100vh;
    min-height: 100dvh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: clamp(8px, 1.6vh, 18px);
    background: url('../../assets/votacaoBackground.webp');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
    z-index: 1;
  }

  .votacao-container {
    width: 100%;
    max-width: none;
    padding: 0;
  }

  .votacao-page-row {
    min-height: calc(100vh - 36px);
    min-height: calc(100dvh - 36px);
  }

  .votacao-col {
    display: flex;
    justify-content: center;
  }

  .texto {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .login {
    width: 100%;
    min-width: 0;
    border-radius: 0 !important;
    background-color: transparent !important;
    opacity: 1;
    padding: 0;
    overflow: visible;
    box-shadow: none !important;
  }

  .votacao-shell {
    border: none;
  }

  .votacao-shell .v-card,
  .votacao-shell .v-stepper {
    background-color: transparent !important;
    box-shadow: none !important;
  }

  .votacao-shell ::v-deep .v-stepper__items,
  .votacao-shell ::v-deep .v-stepper__content {
    background-color: transparent !important;
  }

  .votacao-hero-card {
    min-height: auto;
    border-radius: 0 !important;
    overflow: visible;
    background: transparent !important;
    background-image: none !important;
  }

  .votacao-question-card {
    min-height: auto;
    padding-bottom: 6px !important;
  }

  .votacao-question-title {
    color: #fff;
    max-width: 980px;
    margin: 16px auto 18px;
    padding: 0 14px;
    font-size: clamp(18px, 2.4vw, 28px);
    line-height: 1.25;
    font-weight: 900;
    letter-spacing: 0.2px;
    text-shadow: 0 3px 10px rgba(0, 0, 0, 0.55);
  }

  .votacao-options-grid {
    width: min(100%, 1040px);
    padding: 0 12px 92px;
  }

  .votacao-movie-card {
    padding: 6px;
    border-radius: 16px !important;
    background: rgba(255, 255, 255, 0.05) !important;
    border: 2px solid transparent;
    cursor: pointer;
    overflow: hidden;
    transition: transform 0.16s ease, border-color 0.16s ease, box-shadow 0.16s ease, background 0.16s ease;
  }

  .votacao-movie-card:hover,
  .votacao-movie-card-selected {
    background: rgba(249, 192, 40, 0.14) !important;
    border-color: #F9C028;
    box-shadow: 0 10px 26px rgba(249, 192, 40, 0.18);
    transform: translateY(-2px);
  }

  .votacao-movie-image {
    height: clamp(155px, 28vw, 245px);
    border-radius: 12px;
  }

  .votacao-movie-label {
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: 34px;
    padding: 7px 2px 10px;
    color: #f4f4f4;
    font-size: clamp(13px, 1.8vw, 16px);
    font-weight: 700;
    line-height: 1.18;
    text-align: left;
    cursor: pointer;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.55);
  }

  .votacao-movie-label-selected {
    color: #F9C028;
  }

  .votacao-movie-check {
    width: 24px;
    height: 24px;
    flex: 0 0 24px;
  }

  .votacao-confirm-footer {
    background: #fff !important;
    padding: 12px 16px;
    box-shadow: 0 -8px 22px rgba(0, 0, 0, 0.22);
    z-index: 5;
  }

  .votacao-confirm-card {
    max-width: 980px;
    margin: 0 auto;
    background: #fff !important;
  }

  .votacao-confirm-content {
    background: #fff !important;
    padding: 0 !important;
  }

  .votacao-confirm-btn {
    min-height: 52px !important;
    border-radius: 999px !important;
    color: #1b1b1b !important;
    font-size: clamp(18px, 2.4vw, 24px) !important;
    font-weight: 900 !important;
    letter-spacing: 0.5px;
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.35);
  }

  .votacao-final-card {
    min-height: calc(100vh - 170px);
    min-height: calc(100dvh - 170px);
  }

  .votacao-final-content {
    min-height: inherit;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    padding: 34px 16px 48px;
    text-align: center;
  }

  .votacao-final-logo {
    width: min(300px, 70vw);
    max-height: 145px;
  }

  .votacao-home-btn {
    margin: 0;
  }

  .votacao-final-message {
    margin-top: clamp(14px, 3vh, 34px);
  }

  .votacao-final-message h3 {
    color: #F9C028;
    font-size: clamp(22px, 4vw, 34px);
    line-height: 1;
    margin: 0 0 8px;
    font-weight: 900;
    text-shadow: 0 4px 12px rgba(0, 0, 0, 0.45);
  }

  .votacao-final-message h1 {
    color: #FFFFFF;
    font-size: clamp(42px, 7vw, 72px);
    line-height: 1;
    margin: 0;
    font-weight: 900;
    text-shadow: 0 4px 12px rgba(0, 0, 0, 0.45);
  }

  .votacao-hero-content {
    min-height: inherit;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: clamp(24px, 4vw, 54px);
    position: relative;
    text-align: center;
  }

  .votacao-logo-top {
    width: min(440px, 84vw);
    max-height: 230px;
    margin: 0 auto clamp(28px, 4vh, 48px);
  }

  .votacao-call-row {
    width: 100%;
    margin: 0;
  }

  .votacao-title {
    margin: 0;
    font-size: clamp(26px, 4.4vw, 48px);
    line-height: 0.9;
    font-weight: 900;
    text-shadow: 0 4px 12px rgba(0, 0, 0, 0.45);
  }

  .votacao-title-yellow {
    color: #F9C028;
  }

  .votacao-title-white {
    color: #FFFFFF;
  }

  .votacao-title-last {
    margin-bottom: clamp(24px, 4vh, 42px);
  }

  .votacao-votar-btn {
    width: min(390px, 82vw);
    max-width: 100%;
    cursor: pointer;
    transition: transform 0.15s ease, filter 0.15s ease;
  }

  .votacao-votar-btn:hover {
    filter: brightness(1.05);
    transform: translateY(-1px);
  }

  .login-title {
    text-align: center;
  }

  .login-title-home {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 48px;
    z-index: 4;
  }

  .login-title-flow {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 14px;
    z-index: 3;
    margin: 0;
    pointer-events: none;
  }

  .login-title-with-confirm {
    bottom: 88px;
  }

  .login-title img {
    width: 190px !important;
    filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.35));
  }

  @media (max-width: 599px) {
    .container-login {
      padding: 8px;
    }

    .votacao-page-row {
      min-height: calc(100vh - 16px);
      min-height: calc(100dvh - 16px);
    }

    .votacao-hero-card {
      min-height: auto;
    }

    .votacao-hero-content {
      padding: 24px 14px;
    }

    .votacao-logo-top {
      width: min(400px, 90vw);
      max-height: 245px;
    }

    .votacao-final-card {
      min-height: calc(100vh - 130px);
      min-height: calc(100dvh - 130px);
    }

    .votacao-final-content {
      gap: 16px;
      padding: 28px 14px 40px;
    }

    .votacao-final-logo {
      width: min(260px, 72vw);
      max-height: 130px;
    }

    .login-title-home {
      bottom: 34px;
    }

    .login-title-flow {
      bottom: 12px;
    }

    .login-title-with-confirm {
      bottom: 82px;
    }

    .login-title img {
      width: 170px !important;
    }
  }

  @media (max-height: 700px) {
    .votacao-hero-card {
      min-height: auto;
    }
  }

  a {
    text-decoration: none
  }

  .votacao-hub {
    text-align: center;
    padding: 32px 20px;
  }

  .votacao-hub-texto,
  .votacao-hub-titulo {
    color: #fff;
  }

  .votacao-hub-titulo {
    margin-bottom: 24px;
    font-size: 1.5rem;
  }

  .votacao-hub-btn {
    color: #1a1a1a !important;
    font-weight: bold;
  }
</style>
